"use strict";

require("regenerator-runtime/runtime");


//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/lib/regenerator-runtime/runtime.js
// module id = 20
// module chunks = 0